import { MessageTypes } from "@tmi/types/enums/message-types";
import { Unauthorized } from "@tmi/types/api/responses";
import { useAuthStore } from "@/stores/Auth";
import { storeToRefs } from "pinia";
import pinia from "@/plugins/PiniaPlugin";

export type DataSyncEvent = {
    typeSignifier: string,
    eventType: MessageTypes,
    authToken?: string | undefined | null,
    payload?: string | undefined,
    /**
     * LOAD_COMPLETE: false when the pass did not complete cleanly, so the main thread retries soon.
     * SYNC_STATUS: whether the key's sync reached the server; absent when it did not run this pass.
     */
    ok?: boolean,
    /** SYNC_STATUS only: when the key last synced cleanly on this device (epoch ms), null if it never has. */
    at?: number | null,
    /** REQUEST_SECURE_SYNC only: a member's refresh, which skips the sync cooldowns (UX roadmap #107). */
    force?: boolean
}

export function createDataSyncEvent( evtType: MessageTypes,
                                     payload?: string | undefined,
                                     authToken?: string | undefined ): DataSyncEvent {
    const { isAuthenticated, authToken: jwt } = storeToRefs( useAuthStore( pinia ) );
    if ( !isAuthenticated.value ) {
        throw new Unauthorized();
    }

    const token: string | null = authToken ?? jwt.value;

    return {
        typeSignifier: 'tmi_sync_evt',
        authToken: token,
        eventType: evtType,
        payload: payload
    };
}
